import React from 'react'
import { css as hcss, keyframes } from '@emotion/css'

type Props = {}

const PagilyApp: React.FC<Props> = ({}) => {
  const appLinkBlock = hcss`
    margin-top : 30px; 
    margin-bottom: 80px; 
    display : flex; 

`
  const appLink = hcss`


`
  const appLinkImg = hcss`
    width : 200px; 
    margin-right : 20px; 

`

  return (
    <div className={appLinkBlock}>
      <a href="#beta_subscription" className={appLink}>
        <img
          src="../../img/demo/btn_googleplay.png"
          alt="btn to download app to google play"
          className={appLinkImg}
        />
      </a>
      <a href="#beta_subscription" className={appLink}>
        <img
          src="../../img/demo/btn_appstore.png"
          alt="btn to download app to app store"
          className={appLinkImg}
        />
      </a>
    </div>
  )
}

export default PagilyApp
